<div class="container">
  <div class="search" style="padding-top: 20px">
    <span class="form">
      <mat-form-field class="size">
        <mat-label>Start Dates</mat-label>
        <input
          [(ngModel)]="startdate"
          matInput
          [matDatepicker]="dob"
          (dateChange)="startDateChange($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
        <mat-datepicker #dob></mat-datepicker>
      </mat-form-field>
    </span>
    <span class="form">
      <mat-form-field class="size">
        <mat-label>End Date</mat-label>
        <input
          [(ngModel)]="enddate"
          matInput
          [matDatepicker]="end"
          (dateChange)="endDateChange($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </span>
    <!-- <span class="input" style="position: relative">
        <mat-form-field>
          <mat-label>Filter Mode</mat-label>
          <mat-select [(ngModel)]="filter" matNativeControl>
            <mat-option value="services">Services</mat-option>
          </mat-select>
        </mat-form-field>
      </span> -->
    <!-- <span class="input">
        <mat-form-field class="size">
          <mat-label>Name</mat-label>
          <input [(ngModel)]="name" matInput placeholder="" />
        </mat-form-field>
      </span>
      <span class="input">
        <mat-form-field class="size">
          <mat-label>Mobile No.</mat-label>
          <input type="number" [(ngModel)]="phone" matInput placeholder="" />
        </mat-form-field>
      </span>
      <span class="input" style="position: relative">
        <mat-form-field>
          <mat-label>Gender</mat-label>
          <mat-select [(ngModel)]="gender" matNativeControl>
            <mat-option value="Male">Male</mat-option>
            <mat-option value="Female">Female</mat-option>
          </mat-select>
        </mat-form-field>
      </span> -->
    <!-- <span class="input" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Department</mat-label>
        <mat-select
          [(ngModel)]="dept_code"
          (selectionChange)="dept($event)"
          matNativeControl
        >
          <mat-option *ngFor="let dept of depts" [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span> -->
    <!-- <span class="input" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Sub Department</mat-label>
        <mat-select
          [(ngModel)]="sub_dept_code"
          (selectionChange)="sub($event)"
          matNativeControl
        >
          <mat-option value="0">None </mat-option>
          <mat-option *ngFor="let dept of subDepts" [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span> -->
    <span class="input" *ngIf="filter == 'services'">
      <mat-form-field class="size">
        <mat-label>Service Name</mat-label>
        <input
          type="text"
          [(ngModel)]="investigation"
          matInput
          placeholder=""
        />
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Collected</mat-label>
        <mat-select
          [(ngModel)]="is_collected"
          (selectionChange)="collected($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Acknowledged</mat-label>
        <mat-select
          [(ngModel)]="is_acknowledged"
          (selectionChange)="acknowledged($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Verified</mat-label>
        <mat-select
          [(ngModel)]="is_verified"
          (selectionChange)="verify($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Finalized</mat-label>
        <mat-select
          [(ngModel)]="is_finalized"
          (selectionChange)="finalized($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Printed</mat-label>
        <mat-select
          [(ngModel)]="is_printed"
          (selectionChange)="isprinted($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Online</mat-label>
        <mat-select
          [(ngModel)]="is_online"
          (selectionChange)="isonline($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Authorized</mat-label>
        <mat-select
          [(ngModel)]="is_authorized"
          (selectionChange)="isAuthorized($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Final</mat-label>
        <mat-select
          [(ngModel)]="is_final"
          (selectionChange)="isfinal($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input" style="position: relative" *ngIf="filter == 'services'">
      <mat-form-field>
        <mat-label>Dispatched</mat-label>
        <mat-select
          [(ngModel)]="is_dispatched"
          (selectionChange)="isdispatched($event)"
          matNativeControl
        >
          <mat-option *ngFor="let ver of verif" [value]="ver.value">
            {{ ver.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="input">
      <button
        (click)="clearFilter()"
        style="margin-bottom: 30px; margin-right: 10px"
        mat-raised-button
        color="primary"
      >
        Clear
      </button>
      <button
        (click)="searchEcounters()"
        style="margin-bottom: 30px; margin-left: 0px"
        mat-raised-button
        color="primary"
      >
        Search
      </button>
      <button
        *ngIf="page == '/acknowledge-sample'"
        (click)="scan()"
        style="margin-bottom: 30px; margin-left: 10px"
        mat-raised-button
        color="primary"
      >
        Barcode
      </button>
    </span>
  </div>

  <div class="services all" *ngIf="filter == 'services'">
    <div class="tests">
      <div class="color-code">
        <div class="color-title">
          Typed:
          <div style="background-color: #971ce2"></div>
        </div>
        <div class="color-title">
          Finalized:
          <div style="background-color: limegreen"></div>
        </div>
        <div class="color-title">
          Printed:
          <div style="background-color: #1408cb"></div>
        </div>
        <div class="color-title">
          Pushed Online:
          <div style="background-color: #de7813"></div>
        </div>
      </div>
      <table style="width: 100%" *ngIf="!isLoading">
        <tr class="back">
          <th style="width: 10%">Test ID</th>
          <th style="width: 25%">Patient</th>
          <th style="width: 20%">Service</th>
          <th style="width: 10%">Bill Date</th>
          <th>Status</th>
        </tr>
        <tr
          *ngFor="let item of services"
          style="cursor: pointer"
          [ngClass]="getRowClass(item)"
        >
          <td>{{ item?.sample_id }}</td>
          <td>
            <p class="spnemergency" *ngIf="item.patient_type == 'EMR'">
              ***Emergency***
            </p>
            <p class="statspn">{{ item.registration_no }}</p>
            <p class="statspn">{{ item.patientName }}</p>
            <p class="statspn">
              {{ item.patient_phone }} - {{ item.patient_gender }}
            </p>
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            {{ item.service.service_name }}
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            <span
              *ngIf="isWithinLastWeek(item.billDate)"
              style="
                color: white;
                background-color: blue;
                border-radius: 7px;
                padding: 1px 5px;
              "
            >
              New </span
            ><br />
            <span>{{ item.billDate | date }}</span>
            <div style="color: red">
              {{ item.billDate | date : "mediumTime" }}
            </div>
          </td>
          <td (click)="getSamples(item.Bill_ID)">
            <p class="statspn" *ngIf="item.service.prepared == 'Y'">
              {{
                item.service.prepared_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Typed
            </p>

            <p
              class="statspn"
              *ngIf="
                item.service.prepared == 'N' && item.service.acknowledged == 'Y'
              "
            >
              Pending Result Finalization
            </p>

            <p class="statspn" *ngIf="item.service.finalized_timestamp">
              {{
                item.service.finalized_timestamp | date : "yyyy-MM-dd HH:mm a"
              }}
              - Result Finalized
            </p>

            <p class="statspn" *ngIf="item.service.printed == 'Y'">
              {{ item.service.printed_timestamp | date : "yyyy-MM-dd HH:mm a" }}
              - Result Printed
            </p>

            <p class="statspn" *ngIf="item.service.online == 'Y'">
              {{ item.service.online_timestamp | date : "yyyy-MM-dd HH:mm a" }}
              - Result Online
            </p>
          </td>
        </tr>
      </table>
      <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>
